import {Card, FormControl, FormField} from 'platform/components';
import {Grid, Show, VStack} from 'platform/foundation';

import {ReactNode} from 'react';
import {useWatch} from 'react-hook-form';

import {i18n} from '@dms/i18n';

import {PurchasePriceRuleFormValues} from '../PurchasePriceRuleFormSchema';

interface PurchasePriceRuleModifierCardProps {
  control: FormControl<PurchasePriceRuleFormValues>;
  modifier: keyof PurchasePriceRuleFormValues['modifiers'];
  title: string;
  /** Describes the fixed condition of the modifier. */
  note: string;
  /** Extra fields shown before the percentage while the modifier is on. */
  children?: ReactNode;
  baseTestId: (suffix: string) => string;
}

export function PurchasePriceRuleModifierCard(props: PurchasePriceRuleModifierCardProps) {
  const isEnabled = useWatch({control: props.control, name: `modifiers.${props.modifier}.enabled`});

  return (
    <Card variant="inlineGrey" data-testid={props.baseTestId(`${props.modifier}Card`)}>
      <VStack spacing={4}>
        <FormField
          control={props.control}
          name={`modifiers.${props.modifier}.enabled`}
          type="switch"
          label={props.title}
          aria-label={props.title}
          helperText={props.note}
          data-testid={props.baseTestId(`${props.modifier}Enabled`)}
        />

        <Show when={isEnabled}>
          <Grid columns={2} spacing={4}>
            {props.children}
            <FormField
              control={props.control}
              name={`modifiers.${props.modifier}.percentage`}
              type="number"
              decimalPlaces={2}
              suffix="%"
              label={i18n.t('page.settings.purchasePrice.ruleEditor.modifiers.percentage')}
              helperText={i18n.t(
                'page.settings.purchasePrice.ruleEditor.modifiers.percentageHelper'
              )}
              isRequired
              data-testid={props.baseTestId(`${props.modifier}Percentage`)}
            />
          </Grid>
        </Show>
      </VStack>
    </Card>
  );
}
